import React from "react";

// reactstrap components
import {
    Table,
    Badge,
    DropdownMenu,
    DropdownItem,
    UncontrolledDropdown,
    DropdownToggle,
} from "reactstrap";

class CreditReports extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Report ID</th>
                        <th scope="col">Nama report</th>
                        <th scope="col">Status</th>
                        <th scope="col" />
                    </tr>
                </thead>
                <tbody>
                    {this.props.items.map((item) => (
                        <tr style={{ cursor: 'pointer' }} 
                            onClick={() => this.props.isLunasi && (this.props.selectReport(item))}>
                            <th scope="row">
                                {item.report_id}
                            </th>
                            <td>
                                {item.report_name}
                            </td>
                            <td>
                                <Badge
                                    color={item.status === 0 ? "success" : "warning"}
                                >
                                    {item.status === 0 ? 'Proceed' : 'Not proceed'}
                                </Badge>
                            </td>
                            {!this.props.isLunasi && (
                                <td className="text-right">
                                    <UncontrolledDropdown>
                                        <DropdownToggle
                                            className="btn-icon-only text-light"
                                            role="button"
                                            size="sm"
                                            color=""
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i className="fas fa-ellipsis-v" />
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-arrow" right>
                                            <DropdownItem
                                                onClick={() => this.props.handleProceed(item)}
                                            >
                                                Proceed
                                            </DropdownItem>
                                            <DropdownItem
                                                onClick={() => this.props.handleExportById(item)}
                                            >
                                                Download report
                                            </DropdownItem>
                                            <DropdownItem
                                                onClick={() => this.props.handleExportById(item, true)}
                                            >
                                                Download report UNION
                                            </DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </td>
                            )}
                            {this.props.isLunasi && (
                                <td>

                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </Table>

        )
    };
}

export default CreditReports;
